import "core-js/modules/es.array.push.js";
import Swiper from 'swiper';
import 'swiper/css/swiper.css';
export default {
  name: 'activitysIndex',
  data() {
    return {
      stageUrl: '',
      activityList: []
    };
  },
  methods: {
    _isMobile() {
      let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i);
      return flag;
    },
    openDetail(url) {
      location.href = url;
    },
    toDetail(type) {
      let query = this.$route.query;
      type ? query.type = type : '';
      this.$router.push({
        name: 'activityDetail',
        query
      });
    },
    getActivitys() {
      this.$ajax(`https://cloud-museum.chaoxing.com/api/micro-backend/front/activity/list?params=fid=203966&startTime=2022-09-20 13:10:00`).then(res => {
        res = res.data.data.records;
        this.activityList = res.map(item => {
          return {
            name: item.activityName,
            url: item.activityPreviewUrl,
            img: item.coverUrl
          };
        });
        this.$nextTick(() => {
          this.swiperElNav = new Swiper(this.$refs.swiperList, {
            slidesPerView: 2.8,
            centeredSlides: true,
            spaceBetween: -10,
            loop: true,
            pagination: {
              el: '.activitysIndex .pagination'
            }
          });
        });
      });
    }
  },
  mounted() {
    document.title = '活动平台';
  },
  created() {
    this.stageUrl = process.env.VUE_APP_IMG_URL;
    if (this._isMobile()) {
      this.$cookie.set('_isMobile', true);
    } else {
      this.$cookie.delete('_isMobile');
    }
    this.getActivitys();
  },
  computed: {
    isMobile() {
      return this.$cookie.get('_isMobile');
    }
  }
};